export enum PrinterConfig {
  EPSON = 'epson',
  POSIFLEX = 'posiflex',
}
